import * as tpaRequestsApi from '@/network/api/tpaRequest.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'

/** Requests TPA List
@return {promise} - TPA List Request
*/
export const getListTPAsRequested = async (context, payload) => {
    const res = await tpaRequestsApi.getListTPAsRequested(payload)

    if (res) context.commit('SAVE_TPA_LIST', { pageNumber: payload.pageNumber, data: res.data })

    return res
}

/** Requests Operation Generic Detail
@return {promise} - Operation Generic Detail Request
*/
export const getOperationGenericDetail = async (context, payload) => {
    const res = await operationsApi.getOperationGenericDetail(payload)

    if (res) context.commit('SAVE_OPERATION_DETAIL', res.data.data.lineGroups)

    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
